"use client";
import Dropdown from "@casino/legacyUi/Dropdown";
import SelectFilterOptions from "./SelectFilterOptions";
import useSelectFilter from "./useSelectFilter";

type Props = {
  type: "categories" | "providers";
  menuItem?: string;
  theme?: string;
  placeholder: string;
  selectText: string;
  searchParams: Record<string, string> | undefined;
  className: string;
  dataTestId?: string;
};

const SelectFilter: FC<Props> = ({
  type,
  menuItem,
  theme,
  placeholder,
  selectText,
  searchParams = {},
  className,
  dataTestId,
}) => {
  const { selected, handleChange } = useSelectFilter({ type, searchParams });
  const placeholderText =
    selected.length === 0 ? placeholder : selected.length.toString();

  return (
    <Dropdown
      data-testid={dataTestId}
      size="lg"
      value={selected}
      onChange={(value) => handleChange(value as string[])}
      multiple
      className={className}
    >
      {({ open }) => (
        <>
          <Dropdown.MultiSelect
            open={open}
            label={
              <div className="text-sm/6 text-muted-foreground">
                {selectText}
              </div>
            }
            placeholder={placeholderText}
            className="text-sm/6"
            data-testid={`${dataTestId}-button`}
          />
          <Dropdown.Options className="max-h-96 z-30" menuWidth="w-60">
            <SelectFilterOptions
              type={type}
              menuItem={menuItem}
              theme={theme}
            />
          </Dropdown.Options>
        </>
      )}
    </Dropdown>
  );
};

export default SelectFilter;
